import { render } from "./TheScooterCreationForm.vue?vue&type=template&id=7135230a"
import script from "./TheScooterCreationForm.vue?vue&type=script&lang=js"
export * from "./TheScooterCreationForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__